import React from "react";
import loader from "../../../../assets/UFC_DC_V1/img/loader-review2.svg";

const LoaderOD_V2 = ({ showLoader }) => {
  if (!showLoader) return null;

  return (
    <div className="text-center loader loader1 align-content-center fade-in show">
      <div className="inner py-5">
        <div className="my-3">
          <img height="70" src={loader} alt="Loading..." />
        </div>
        <h2 className="px-4"> Please wait...</h2>
      </div>
    </div>
  );
};

export default LoaderOD_V2;
